class IsLoggedIn extends HTMLElement {
  connectedCallback() {
    this.checkAuthStatus();
  }

  async checkAuthStatus() {
    let domain = this.getAttribute("domain") || "",
      origin = new URL(window.location).origin,
      fetchOpts = {
        method: "HEAD",
        redirect: "manual",
      };

    if (domain && domain !== origin) {
      // only needed in local dev mode when consumer and tq_site are on different ports and considered cross origin
      fetchOpts["credentials"] = "include";
    }

    let response = await fetch(`${domain}/users/profile/`, fetchOpts);
    if (response.status == 200) {
      this.setAttribute("logged-in", true);
    }
  }
}

customElements.define("is-logged-in", IsLoggedIn);
